import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledDropdown } from "reactstrap";
import TableModify from "../components/common/table-modify";
import Select from "react-select";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ConfigData from '../config.json';


const UserList = () => {
    const [isShowModal, setIsShowModal] = useState();
    const [dataTable, setDataTable] = useState([]);
    const [selectEmployee, setSelectEmployee] = useState("");
    const [ddlEmployee, setDdlEmployee] = useState([]);
    const [dataDetail, setDataDetail] = useState({
        id: 0,
        id_employee_general: "",
        employee_id: "",
        email: "",
        name: "",
        surname: "",
        employee_pic: "",
    });

    useEffect(() => {
        LoadDataTable();
        LoadDataDdlEmployee();
    }, []);

    const column = [
        {
            key: "id",
            name: <span className='font-weight-bold fs-13'>No.</span>,
            cell: (row, index) => index+1,
            width: "5%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: false
        },
        {
            key: "employee_id",
            name: <span className='font-weight-bold fs-13'>Employee ID</span>,
            cell: (row, index) => row.employee_id,
            width: "20%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "name",
            name: <span className='font-weight-bold fs-13'>First name</span>,
            cell: (row, index) => row.name,
            width: "20%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "surname",
            name: <span className='font-weight-bold fs-13'>Last name</span>,
            cell: (row, index) => row.surname,
            width: "25%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "email",
            name: <span className='font-weight-bold fs-13'>Email</span>,
            cell: (row, index) => row.email,
            width: "20%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "action",
            name: <span className='font-weight-bold fs-13'></span>,
            cell: (row, index) => {
                return(
                    <UncontrolledDropdown key={index}>
                        <DropdownToggle tag="button" className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="ri-more-2-fill"></i></DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <li>
                                <DropdownItem onClick={() => onClickUpdate(row)}>
                                    <i className="ri-pencil-fill"></i> Edit
                                </DropdownItem>
                            </li>
                            <li>
                                <DropdownItem onClick={() => onClickDelete(row.id)}>
                                    <i className="ri-delete-bin-line"></i> Delete
                                </DropdownItem>
                            </li>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                )
            },
            width: "10%",
            classHeader: "text-start",
            classBody: "text-end",
            sortable: false
        }
    ];

    const onClickAdd = () => {
        validation.resetForm();
        setSelectEmployee(null);
        setDataDetail({
            id: 0,
            id_employee_general: "",
            employee_id: "",
            email: "",
            name: "",
            surname: "",
            employee_pic: "",
        });
        setIsShowModal(!isShowModal);
    };

    const onClickUpdate= (data) => {
        validation.resetForm();
        setSelectEmployee(ddlEmployee.find(x => x.value === data.id_employee_general.toString()));
        setDataDetail({
            id: data.id,
            id_employee_general: data.id_employee_general,
            employee_id: data.employee_id,
            email: data.email,
            name: data.name,
            surname: data.surname,
            employee_pic: data.employee_pic,
        });
        setIsShowModal(!isShowModal);
    };

    const onClickDelete = (id) => {
        Swal.fire({
            title: 'Are you sure ?',
            text: 'Once you delete, you can not undo it!',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            confirmButtonColor: '#dc3741',
        }).then((result) => {
            if(result.isConfirmed){
                DeleteUser(id);
            }
        });
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            id_employee_general: dataDetail.id_employee_general || 0,
            employee_id: dataDetail.employee_id || "",
            email: dataDetail.email || "",
            name: dataDetail.name || "",
            surname: dataDetail.surname || "",
            employee_pic: dataDetail.employee_pic || "",
        },
        validationSchema: Yup.object({
            id_employee_general: Yup.string().required("Please select a Employee"),
        }),
        onSubmit: (values) => {
            values.id_employee_general = (values.id_employee_general !== "") ? parseInt(values.id_employee_general) : 0;
            let objEmp = ddlEmployee.find(x => x.value === values.id_employee_general.toString())
            values.employee_id = objEmp.employee_id;
            values.name = objEmp.name;
            values.surname = objEmp.surname;
            values.email = objEmp.email;
            values.employee_pic = objEmp.employee_pic
            if(values.id > 0){
                UpdateUser(values);
            }else{
                AddUser(values);
            }
        }
    });

    const LoadDataTable = () => {
        let url = ConfigData.API_URL + "user/?status=1";
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setDataTable(respData.data);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadDataDdlEmployee = () => {
        let url = ConfigData.API_URL_HRIS + "employee-general/grid?status=1";
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                const arrData = respData.data.map((e) => {
                    return {
                        label: e.name_en + " " + e.surname_en,
                        value: e.id.toString(),
                        name: e.name_en,
                        surname: e.surname_en,
                        employee_id: e.employee_id,
                        email: e.office_email,
                        employee_pic: e.employee_pic,
                    };
                });
                setDdlEmployee(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const AddUser = (data) => {
        let url = ConfigData.API_URL + "user/";
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        let userId = sessionStorage.getItem("uid");
        axios.post(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(!isShowModal);
                Swal.fire({
                    icon: 'success',
                    title: 'Add data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Failed to add data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const UpdateUser = (data) => {
        let url = ConfigData.API_URL + "user/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        let userId = sessionStorage.getItem("uid");
        axios.put(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Edit data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Failed to update data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const DeleteUser = (id) => {
        let url = ConfigData.API_URL + "user/" + id;
        let token = "Bearer " + sessionStorage.getItem("tokenmeetingunicorn");
        let userId = sessionStorage.getItem("uid");
        axios.delete(url, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                Swal.fire({
                    icon: 'success',
                    title: 'Delete data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <TableModify data={dataTable} column={column} rowPerPage={25} onClickAdd={onClickAdd} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Modal Add and Edit */}
            <Modal id="modalDepartment"
                isOpen={isShowModal}
                toggle={() => { setIsShowModal(!isShowModal); }}
                backdrop={'static'}
                centered
            >
                <ModalHeader id="modalDepartmentHeader" 
                    className="modal-title"
                    toggle={() => { setIsShowModal(!isShowModal); }}
                >
                    {(dataDetail.id <= 0) ? "Create user" : "Edit user"}
                </ModalHeader>
                <ModalBody>
                    <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="ddlEmployee">Employee</Label>
                                    <Select id="ddlEmployee"
                                        name="id_employee_general"
                                        value={selectEmployee}
                                        onChange={(selected) => {
                                            setSelectEmployee(selected);
                                            validation.handleChange('id_employee_general')((selected !== null) ? selected.value : "");
                                        }}
                                        options={ddlEmployee}
                                        isClearable={true}
                                        isSearchable={true}
                                        invalid={ validation.touched.id_employee_general && validation.errors.id_employee_general ? true : false }
                                    />
                                    { validation.touched.id_employee_general && validation.errors.id_employee_general ? 
                                        ( <FormFeedback type="invalid" style={{display: "block"}}>{validation.errors.id_employee_general}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <Button color="primary" type="button" onClick={() => setIsShowModal(false) } >
                                    Close
                                </Button>
                                <Button className="float-end" color="success" type="submit">
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default UserList;